"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rtp = void 0;
class Rtp {
    constructor(api) {
        this._formatters = [];
        api.events.on('rtp', (r) => {
            const type = typeof r;
            if (type === 'object') {
                const rtp = r;
                if (rtp.single) {
                    this._formatters.push({
                        target: 'span.rtp',
                        value: Rtp.formatRTP(rtp.single, null, api.options.language)
                    });
                    api.gameInfo.formattedRtp = Rtp.formatRTP(rtp.single, null, api.options.language);
                }
                else {
                    api.gameInfo.formattedRtp = Rtp.formatRTP(rtp.min, null, api.options.language) + " - " + Rtp.formatRTP(rtp.max, null, api.options.language);
                }
                if (rtp.min) {
                    this._formatters.push({
                        target: 'span.min-rtp',
                        value: Rtp.formatRTP(rtp.min, null, api.options.language)
                    });
                }
                if (rtp.max) {
                    this._formatters.push({
                        target: 'span.max-rtp',
                        value: Rtp.formatRTP(rtp.max, null, api.options.language)
                    });
                }
                if (rtp.features) {
                    Object.keys(rtp.features).forEach(f => {
                        const feature = rtp.features[f];
                        if (feature) {
                            if (feature.single) {
                                this._formatters.push({
                                    target: 'span.rtp-' + f,
                                    value: Rtp.formatRTP(feature.single, null, api.options.language)
                                });
                            }
                            if (feature.min) {
                                this._formatters.push({
                                    target: 'span.min-rtp-' + f,
                                    value: Rtp.formatRTP(feature.min, null, api.options.language)
                                });
                            }
                            if (feature.max) {
                                this._formatters.push({
                                    target: 'span.max-rtp-' + f,
                                    value: Rtp.formatRTP(feature.max, null, api.options.language)
                                });
                            }
                        }
                    });
                }
            }
            else if (type === 'string' || type === 'number') {
                this._formatters.push({
                    target: 'span.rtp',
                    value: Rtp.formatRTP(r, null, api.options.language)
                });
                api.gameInfo.formattedRtp = Rtp.formatRTP(r, null, api.options.language);
            }
        });
    }
    static formatRTP(value, fractionDigits, language) {
        if (fractionDigits === undefined || fractionDigits === null) {
            if (value === 0.9800) { // Special handling for DX2 games until platform provides fraction digits
                fractionDigits = 1;
            }
            else {
                fractionDigits = 2;
            }
        }
        return value.toLocaleString(language, {
            style: 'percent',
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
        });
    }
    ;
    updateScreen(screen) {
        for (let formatter of this._formatters) {
            const result = screen.find(formatter.target);
            for (let element of result) {
                element.textContent = formatter.value;
            }
        }
    }
}
exports.Rtp = Rtp;
//# sourceMappingURL=Rtp.js.map